export default "__VITE_ASSET__DwT8oHDA__"